const initialState = {
  dashboardData: [],
  loading: false,
  toastMessage: "",
  toastOpen: false,
  error: null,
  loadError: null,
  isLoaded: null,
  customerAddedSucess: false,
  customerEditedSuccess: false,
  editError: null,
  customerData: [],
};
const CustomerManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case "BUILDING_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "BUILDING_DATA_SUCCESS":
      return {
        ...state,
        dashboardData: action.payload,
        loading: false,
        error: null,
      };
    case "BUILDING_DATA_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        dashboardData: [],
      };

    case "DELETE_CUSTOMER_SUCCESS":
      return {
        ...state,
        // message: action.payload,
        error: null,
      };

    case "DELETE_CUSTOMER_FAIL":
      return {
        ...state,
        // message: action.payload,
        error: action.payload,
      };
    case "ADD_CUSTOMER_REQUEST": 
      return {
        ...state,
        customerAddedSucess: false,
        error: null,
      };
    case "ADD_CUSTOMER_SUCCESS":
      return {
        ...state,
        customerAddedSucess: true,
      };
    case "ADD_CUSTOMER_FAIL":
      return {
        ...state,
        customerAddedSucess: false,
        error: action.payload,
      };
    case "ADD_CUSTOMER_MODAL_CLEAR":
      return {
        ...state,
        customerAddedSucess: false,
      };
    case "SET_TOAST_MESSAGE":
      return {
        ...state,
        toastMessage: action.payload,
      };
    case "SET_TOAST_OPEN":
      return {
        ...state,
        toastOpen: action.payload,
      };

    case "MAP_DATA":
      return {
        ...state,
        mapData: action.payload,
      };
    case "MAP_MARKER_DATA":
      return {
        ...state,
        markerData: action.payload,
      };
    case "RESET_MARKER_DATA":
      return {
        ...state,
        mapData: {},
        markerData: {},
      };
    case "ISLOADED_LOADERROR":
      return {
        ...state,
        loadError: action.payload.loadError,
        isLoaded: action.payload.isLoaded,
      };
    case "EDIT_CUSTOMER_REQUEST":
      return {
        ...state,
        loading: true,
        customerEditedSuccess: false,
        editError: null,
      };
       case "EDIT_ERROR_CLEAR":
      return {
        ...state,
        editError: null,
      };
    case "EDIT_CUSTOMER_SUCCESS":
      return {
        ...state,
        loading: false,
        customerEditedSuccess: true,
      };

    case "EDIT_CUSTOMER_FAILURE":
      return {
        ...state,
        loading: false,
        customerEditedSuccess: false,
        error: action.payload,
      };
    case "EDIT_CUSTOMER_MODAL_CLEAR":
      return {
        ...state,
        customerEditedSuccess: false,
      };
    case "CUSTOMER_DATA_SUCCESS":
      return {
        ...state,
        customerData: action.payload,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default CustomerManagementReducer;
